export const d = {
  header: "80px",
  footer: "300px",
  radius: "5px",
};

export const phone = {
  padding: "16px",
  gap: "16px",
};

export const tablet = {
  padding: "32px",
  gap: "32px",
};

export const computer = {
  padding: "20vw",
  gap: "20vw",
};
